import { useTranslation } from 'react-i18next'
import { Box, Button, Fab, Grid, Tooltip } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import SliderField from 'components/atoms/fields/SliderField'
import { ICourseComponent } from 'types'
import SelectField from 'components/atoms/fields/SelectField'
import { selectYesNo } from 'utils/helpers'
import { cloneDeep } from 'lodash'
import { FaTrashAlt } from 'react-icons/fa'
import { Add } from '@mui/icons-material'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const CourseComponentList = ({ fieldProps, defaultOnly=true, showImportance=true, disabled=true }) => {
  
  const { t } = useTranslation()
  const [field] = useField<ICourseComponent[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state


  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        id: '',
        title: '',
        importance: 0,
        is_modifiable: {id: 'yes', title: t('common.yes')},
      },
    ])
  }

  const handleRemoveEntity = (index: number) => {
    // Clone the original array
    const entities = cloneDeep(field.value)
    // Entity from array
    entities.splice(index, 1)
    setFieldValue(fieldProps.name, entities)
  }


  return (
    <>
     
     <Box className="transparent-background" padding={2}sx={{ display: 'flex', alignItems: 'flex-end', width: '100%', marginBottom: '40px' }}>
        <Box className="transparent-background">
            {!defaultOnly && <>
              <div><b>{t('common.grading-categories-for-course')}</b></div>
              {/*<div><b>{t('common.grading-categories-configuration')}</b></div>*/}
            </>}

          <div><b>{t('common.grading-categories-total')}</b></div>
        </Box>


        {defaultOnly &&   
           <Box sx={{ marginLeft: 'auto'  }} className="transparent-background">
                      <Tooltip title={`${t('common.add')}`} arrow placement='top'>
                        <Fab
                          aria-label='add'
                          size='small'
                          disabled={disabled}
                          onClick={handleAddEntity}
                          color='success'
                          sx={{ boxShadow: 'none', width: 'auto', padding: '0px 10px', fontWeight: 'bold', textTransform: 'uppercase' }}
                        >
                          <Add style={{ fontSize: '1.8rem' }} />  {t('common.add-category')}
                        </Fab>
                      </Tooltip>
           </Box>   
        } 
     </Box>
          
      { 
        field.value.map((value: ICourseComponent, index: number) => ( 
                
          <Box 
            className={'transparent-background'}
            key={ index }
            sx={{
              padding: '1rem',
            }}>
            <Grid
              container
              spacing={4}
              sx={{ alignItems: 'flex-start' }}
            >
              {
                !defaultOnly && <Grid item xs={3} lg={1} sx={{ textAlign: 'right '}}>
                   <CheckboxField 
                      isSwitch={true}
                      valueSelector='is_enabled'
                      fieldProps={{
                        label: '',
                        name: `${fieldProps.name}[${index}]`,
                      }} 
                      index={index}
                      disabled={disabled}
                    />
                </Grid>
              }
              <Grid item xs={9} lg={3}>
                <InputField
                  valueSelector='title'
                  fieldProps={{
                    label: t('common.category-title'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled || (!defaultOnly && (!value.is_modifiable || !value.is_enabled))}
                />
              </Grid>
              {defaultOnly &&
              <Grid item xs={12} lg={2}>
                <SelectField
                  valueSelector='is_modifiable'
                  fieldProps={{
                    label: t('common.modifiable-for-course'),
                    name: `${fieldProps.name}[${index}]`,
                    required: true,
                  }}
                  apiCall={() => selectYesNo()}
                  disabled={disabled || !defaultOnly}
                />
                <div className="input-label">{t('common.grading-catgory-can-be-adjusted')}</div>
              </Grid> 
              }

              {showImportance && <>
              <Grid item xs={12} lg={2}>
                <InputField
                  valueSelector='importance'
                  inputProps={{
                    type: 'number',
                    min: 0,
                    max: 100
                  }}
                  fieldProps={{
                    label: t('common.category-weight'),
                    name: `${fieldProps.name}[${index}]`,
                    type: 'number'
                  }}
                  disabled={disabled || (!defaultOnly && (!value.is_modifiable || !value.is_enabled))}
                />
                <div className="input-label">{t('common.defines-weight-final-grade')}</div>
              </Grid>

              <Grid item xs={10} lg={4}>
                <div style={{ position:"relative", marginTop: "-20px" }}>
                <SliderField
                  valueSelector='importance'
                  fieldProps={{
                    label: t('common.importance'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled || (!defaultOnly && (!value.is_modifiable || !value.is_enabled))}
                  min={0}
                  max={100}
                  step={5}
                />
                </div>
              </Grid></>}

              {defaultOnly && 
              <Grid item xs={2} lg={1} sx={{ textAlign: 'right' }}>
                <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
                    <Button
                      onClick={() => handleRemoveEntity(index)}
                      aria-label='delete'
                      size='small'
                      disabled={disabled}
                      color='error'
                      variant='outlined'
                      sx={{ margin: '0', boxShadow: 'none', padding: '0.5rem 0.1rem', minWidth: '2.5rem !important', maxWidth: '2.5rem !important'  }}
                    >
                      <FaTrashAlt style={{ fontSize: '1.2rem' }} />
                    </Button>
                  </Tooltip>
              </Grid>
              }
            </Grid>
          </Box>
        ))
      }      
    </>
  )

}
export default CourseComponentList


